import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <p>&copy; A Pawn ForWard 2024. All rights reserved.</p>
          <p>&#9993; Contact me: <a style={{color: '#FFFFFF'}} href="mailto:zhangqianggis@sina.com">zhangqianggis@sina.com</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;